import { render, staticRenderFns } from "./Reset-password.vue?vue&type=template&id=a65551fc&scoped=true&"
import script from "./Reset-password.vue?vue&type=script&lang=js&"
export * from "./Reset-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65551fc",
  null
  
)

export default component.exports